import { Drawer } from '@mui/material';
import PanelCopiloto from 'src/components/copiloto/PanelCopiloto';
import { useCopiloto } from 'src/contexts/copiloto-context';

/**
 * El cajón donde vive el copiloto, montado una sola vez a nivel app.
 *
 * `persistent` y no `temporary`: un cajón modal apaga la página detrás con un
 * velo y deja de poder tocarse. Eso mataría lo único que hace que aceptar una
 * propuesta no sea a ciegas —el copiloto resalta las filas de las que habla
 * MIENTRAS habla— y la idea es mirar la obra al mismo tiempo que la conversación,
 * no en lugar de ella. Sin velo, el panel se apoya sobre el borde derecho y la
 * pantalla sigue viva.
 *
 * Como no es modal, los hijos quedan montados con el cajón cerrado: el hilo y el
 * historial cargado son de la sesión, no de esta vez que se abrió.
 *
 * Que no tape nada no lo resuelve el cajón: `persistent` se apoya sobre la página
 * y no reserva lugar, así que el lugar lo reserva el contenido. Por eso el ancho
 * se exporta: lo lee `CorrimientoCopiloto`, el envoltorio de `_app` por el que
 * pasan todas las pantallas —no sólo las del layout del dashboard—.
 */

/**
 * De `md` para abajo el copiloto toma la pantalla entera: en 400 px de ancho la
 * conversación y la obra no conviven, y correr el contenido dejaría la obra en una
 * franja ilegible. El mismo corte que ya usan `top` y `height` acá abajo.
 */
export const ANCHO_COPILOTO = 400;

export default function CopilotoDrawer() {
  const { abierto } = useCopiloto();

  return (
    <Drawer
      anchor="right"
      variant="persistent"
      open={abierto}
      PaperProps={{
        sx: {
          width: { xs: '100%', md: ANCHO_COPILOTO },
          borderLeft: '1px solid',
          borderColor: 'divider',
          boxShadow: (t) => t.shadows[8],
          // El cajón se apoya sobre la página, no la reemplaza: arranca abajo de
          // la barra de arriba para no tapar de dónde salió.
          top: { xs: 0, md: 64 },
          height: { xs: '100%', md: 'calc(100% - 64px)' },
        },
      }}
    >
      <PanelCopiloto />
    </Drawer>
  );
}
